import { errors } from "../utils/errors-code.json";

export const getErrorMessage = (code, language = "fr") => {
  const error = errors.find((error) => error.code === code);
  return error ? error.message[language] : errors[0].message[language];
};
